var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"follow",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('p',{staticClass:"text-center"},[_vm._v("\n        Follow\n        "),_c('a',{attrs:{"href":"https://www.instagram.com/chef_naturelle/","target":"_blank"}},[_vm._v("@chef_naturelle")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }